import secureAxios from '../secure_axios';

const baseUrl = 'grupo-usuario'

async function servGetGruposPorCPF(cpf) {
    return await secureAxios.get(`${baseUrl}/por-cpf`, {
        params: { cpf }
    })
}

async function servAssociaGrupo(associacao) {
    return await secureAxios.post(`${baseUrl}/associar`, associacao)
}

async function servDesassociaGrupo(grupoUsuarioId, usuarioId) {
    return await secureAxios.delete(`${baseUrl}/desassocia`, {
        params: { grupoUsuarioId, usuarioId }
    })
}

export {
    servGetGruposPorCPF,
    servAssociaGrupo,
    servDesassociaGrupo
}